// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar-1zcef","root":"root-1PLEO","title":"title-1Lec2"};